import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';

import ProductSelectionPage from '../../../components/ProductSelectionPage/motorplay';
import { selectCurrentContentFichaPath } from '../../../queries/selectors/contents';
import { selectUserData } from '../../../queries/selectors/user';

import withNoMembershipPurchased from '../../withNoMembershipPurchased';
import { selectClient, selectProductToUpgrade, selectSearchObj } from '../../../global-selectors';
import { selectCurrentPaymentMethod } from '../../../queries/selectors/payment';
import withAuthGuard from '../../withAuthGuard';
import { addProduct, cleanOrder } from '../../../queries/actions/shoppingCart';
import { selectProductTypePlan, selectSingleSubscriptionClient } from '../../../queries/selectors/bootstrap';
import { resetProductExchange, updateInitialExchangeByDeviceCountry } from '../../../queries/actions';
import { selectProducts } from '../../../queries/selectors/products';
import { applyProductRules } from '../../../queries/actions/rules';
import { injectIntl } from 'react-intl';

const mapStateToProps = state => ({
  path: selectCurrentContentFichaPath(state),
  user: selectUserData(state),
  productToUpgradeId: selectProductToUpgrade(state),
  paymentMethod: selectCurrentPaymentMethod(state),
  products: selectProducts(state),
  plans: selectProductTypePlan(state),
  isSingleSubscriptionClient: selectSingleSubscriptionClient(state),
  client: selectClient(state),
  queryParamsObject: selectSearchObj(state)
});

const mapDispatchToProps = (
  (dispatch) => bindActionCreators({
    cleanOrder: payload => dispatch(cleanOrder(payload)),
    addProduct: payload => dispatch(addProduct(payload)),
    resetProductExchange: () => resetProductExchange(),
    applyProductRules: (data) => dispatch(applyProductRules(data)),
    updateInitialExchangeByDeviceCountry: payload => updateInitialExchangeByDeviceCountry(payload)
  }, dispatch)
);

export default compose(
  withAuthGuard({ toLoginURL: true }),
  withNoMembershipPurchased,
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl
)(ProductSelectionPage);
